export default __webpack_public_path__ + "static/media/undraw_software.4230e6f2.svg";